import React from 'react';
import { SerializedStyles, css } from '@emotion/react';
import { useTheme } from '@veneer/theme';
import { Property } from 'csstype';

import { TooltipInterface } from './types';

const useStyles = ({
  maxWidth,
  userSelect,
}: {
  maxWidth: TooltipInterface['maxWidth'];
  userSelect: Property.UserSelect;
}): {
  root: SerializedStyles;
  tooltip: {
    root: SerializedStyles;
    hc: SerializedStyles;
  };
} => {
  const theme = useTheme();

  return React.useMemo(() => {
    return {
      root: css({
        userSelect,
      }),
      tooltip: {
        root: css({
          backgroundColor: theme.color.spotlight.background.default,
          borderColor: theme.color.spotlight.background.default,
          borderRadius: theme.borderRadius2,
          boxSizing: 'border-box',
          color: theme.color.spotlight.base.default,
          minHeight: theme.layout.size6,
          maxWidth: maxWidth || 300,
          padding: `${theme.layout.size1} ${theme.layout.size2}`,
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          position: 'relative',
          ...theme.typography.labelSmall,
        }),
        hc: css({
          backgroundColor: theme.color.background.container.default,
          color: theme.color.foreground.default,
          borderWidth: '2px',
          borderStyle: 'solid',
        }),
      },
    };
  }, [maxWidth, theme, userSelect]);
};

export default useStyles;
